import axios from 'axios';

/**
 * Api Url
 */
const apiUrl = 'https://3x5zu0ke25.execute-api.eu-west-1.amazonaws.com/prod';

/**
 * Token
 */
const token = 'abdNX0aNtu6XdGpoNkUqOnn';

/**
 * Instance
 */
const instance = axios.create({
  baseURL: apiUrl,
  headers: { token }
});

export { instance };
